import { render, staticRenderFns } from "./map-box-map.vue?vue&type=template&id=2d163a3d&scoped=true"
import script from "./map-box-map.vue?vue&type=script&lang=js"
export * from "./map-box-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d163a3d",
  null
  
)

export default component.exports